module.exports = __webpack_public_path__ + "static/media/Receivership-Order-Applicant-Marshallzehr179820.1.7c8924c7.pdf";